var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.85 45.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 1laptop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.38.35A1.09,1.09,0,0,0,23.59,0H6A6,6,0,0,0,0,5.93V39.31a6,6,0,0,0,6,5.93h24a6,6,0,0,0,6-5.93V12.81a1.21,1.21,0,0,0-.32-.77Zm.32,3.51,7.46,7.83H27.31a2.6,2.6,0,0,1-2.61-2.6Zm5.2,39.2H6a3.79,3.79,0,0,1-3.76-3.75V5.93A3.78,3.78,0,0,1,6,2.19H22.51v6.9a4.78,4.78,0,0,0,4.8,4.79h6.35V39.31A3.79,3.79,0,0,1,29.9,43.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.92,35.52h-18a1.09,1.09,0,1,0,0,2.18h18a1.09,1.09,0,1,0,0-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.12,31.59a1.11,1.11,0,0,0,.8.35,1.1,1.1,0,0,0,.8-.35l6.4-6.87a1.09,1.09,0,1,0-1.59-1.49L19,28.08V16.14a1.1,1.1,0,0,0-2.19,0V28.08l-4.5-4.85a1.09,1.09,0,0,0-1.6,1.49Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.d6f019fc2fc55b30724fda29bee8bafa.svg";
export { ForwardRef as ReactComponent };